const actions = {
  setSelectedOrder ({ commit }, order) {
    //- Mutate store
    commit('SET_SEL_ORDER', order)
  },
  updateSelectedOrder ({ commit }, order) {
    //- Mutate store
    commit('UPDATE_SEL_ORDER', order)
  }
}

export default actions
